var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightDownloadAppBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 498,
    height: 120,
    viewBox: "0 0 498 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1181_130625",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 498,
    height: 120
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 38.64C0.5 31.7977 0.500402 26.6966 0.836044 22.6549C1.17119 18.6192 1.838 15.6847 3.14578 13.1671C5.37536 8.87499 8.87499 5.37536 13.1671 3.14578C15.6847 1.838 18.6192 1.17119 22.6549 0.836044C26.6966 0.500402 31.7977 0.5 38.64 0.5H459.36C466.202 0.5 471.303 0.500402 475.345 0.836044C479.381 1.17119 482.315 1.838 484.833 3.14578C489.125 5.37536 492.625 8.87499 494.854 13.1671C496.162 15.6847 496.829 18.6192 497.164 22.6549C497.5 26.6966 497.5 31.7977 497.5 38.64V81.36C497.5 88.2023 497.5 93.3034 497.164 97.3451C496.829 101.381 496.162 104.315 494.854 106.833C492.625 111.125 489.125 114.625 484.833 116.854C482.315 118.162 479.381 118.829 475.345 119.164C471.303 119.5 466.202 119.5 459.36 119.5H38.64C31.7977 119.5 26.6966 119.5 22.6549 119.164C18.6192 118.829 15.6847 118.162 13.1671 116.854C8.87499 114.625 5.37536 111.125 3.14578 106.833C1.838 104.315 1.17119 101.381 0.836044 97.3451C0.500402 93.3034 0.5 88.2023 0.5 81.36V38.64Z",
    fill: "white",
    stroke: "#ECECEC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1181_130625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319 118.735C364.905 128.554 402.39 1.26542 472.911 40.5503C543.431 79.8351 520.812 100.774 615.948 135.464C711.084 170.155 698.443 223.832 698.443 242.817C698.443 261.802 374.448 222.524 374.448 222.524L319 118.735Z",
    fill: "url(#paint0_linear_1181_130625)",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1181_130625",
    x1: 578.175,
    y1: 68.5214,
    x2: 565.665,
    y2: 198.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6CE",
    stopOpacity: 0.341
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BC231",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightDownloadAppBg);
export default __webpack_public_path__ + "static/media/lightDownloadAppBG.db4c026220da7e5ef3888f5478b6bce2.svg";
export { ForwardRef as ReactComponent };